// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var JwtSubscriptionStatus = function (x) {
    return x;
};
var tsBridgeJwtSubscriptionSt = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("JwtSubscriptionStatus")("__brandJwtSubscriptionStatus"));
    }
};
var writeJwtSubscriptionStatus = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showJwtSubscriptionStatus = Data_Show.showString;
var readJwtSubscriptionStatus = Simple_JSON.readString;
var ordJwtSubscriptionStatus = Data_Ord.ordString;
var newtypeJwtSubscriptionStatus = {
    Coercible0: function () {
        return undefined;
    }
};
var makeJwtSubscriptionStatus = JwtSubscriptionStatus;
var eqJwtSubscriptionStatus = Data_Eq.eqString;
export {
    JwtSubscriptionStatus,
    makeJwtSubscriptionStatus,
    unwrap,
    newtypeJwtSubscriptionStatus,
    eqJwtSubscriptionStatus,
    ordJwtSubscriptionStatus,
    showJwtSubscriptionStatus,
    readJwtSubscriptionStatus,
    writeJwtSubscriptionStatus,
    tsBridgeJwtSubscriptionSt
};
//# sourceMappingURL=index.js.map
